import type { ConditionField, DimensionDescriptor, FunctionDescription } from "../../../../../../../../../api/types/svTypes.ts";
import { DimensionNames } from "../../../../../utilities/DimensionNames";
import type { IFormulaVariable } from "./variables";
import { FunctionFormulaVariable } from "./variables";

export const getFunctionVariables = (functions: FunctionDescription[]): IFormulaVariable[] => {
  return functions.map((func) => new FunctionFormulaVariable(func));
};

const availableDimensions = [
  DimensionNames.AccountCategory,
  DimensionNames.AccountNo,
  DimensionNames.AccountName,
  DimensionNames.TransactionCode,
  DimensionNames.AccountingBook,
];

export const getAvailableDimensions = (dimensions: DimensionDescriptor[], isMultibook: boolean) => {
  const actualDimensions = isMultibook
    ? availableDimensions
    : availableDimensions.filter((d) => d !== DimensionNames.AccountingBook);
  return dimensions.filter((d) => actualDimensions.includes(d.name));
};

export const orderCustomMeasureConditions = (conditions: ConditionField[]): ConditionField[] => {
  const accountingBook = conditions.find((condition) => condition.meta.name === DimensionNames.AccountingBook);
  return accountingBook === undefined
    ? conditions
    : [accountingBook, ...conditions.filter((condition) => condition !== accountingBook)];
};
